import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, FormikContextType, FormikProvider } from 'formik';
import { Box } from '@mui/system';
import { StaffErrors } from '../StaffList';
import useStaffRolesOptions from '../../../helperHooks/useStaffRolesOptions';
import useLocations from '../../../helperHooks/useLocations';
import FormikTextField from '../../../components/formikComponents/FormikTextField';
import FormikSelect from '../../../components/formikComponents/FormikSelect';
import FormikCheckbox from '../../../components/formikComponents/FormikCheckbox';
import { STAFF_CACHE_KEY } from '../../../constants';
import SideFormActions from '../../../components/createEditComponents/SideFormActions';

export interface StaffRole {
  id: string;
  name: string;
  description: string;
}

type StaffFormProps = {
  formik: FormikContextType<any>;
  cancelAction: () => void;
  objectId: string;
  isSubmitting: boolean;
  errors: StaffErrors;
  clearError: (errorKey: string) => void;
};
const StaffForm = ({
  formik,
  cancelAction,
  objectId,
  isSubmitting,
  errors,
  clearError,
}: StaffFormProps) => {
  const { t } = useTranslation();
  const { staffRolesOptions } = useStaffRolesOptions();
  const { locations } = useLocations();

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <FormikTextField
          label={t('screens.staff.name')}
          id="name"
          required
          invalidPattern={/[#']/g}
          objectId={objectId}
          formName={STAFF_CACHE_KEY}
          name="name"
          error={errors?.name}
          clearError={clearError}
        />
        <FormikSelect
          label={t('screens.staff.mainLocation')}
          id="mainLocationId"
          name="mainLocationId"
          options={locations}
          formName={STAFF_CACHE_KEY}
          objectId={objectId}
          error={errors?.mainLocationId}
          clearError={clearError}
        />
        <Box sx={{ marginTop: '-0.5rem', marginBottom: '1.5rem' }}>
          <FormikCheckbox
            label={t('screens.staff.showAtAllLocations')}
            id="showAtAllLocations"
            name="showAtAllLocations"
            type="checkbox"
            formName={STAFF_CACHE_KEY}
            objectId={objectId}
          />
        </Box>
        <FormikSelect
          label={t('screens.staff.roleName')}
          required
          id="staffRoleId"
          name="staffRoleId"
          options={staffRolesOptions}
          formName={STAFF_CACHE_KEY}
          objectId={objectId}
          error={errors?.staffRoleId}
          clearError={clearError}
        />
        <FormikTextField
          label={t('screens.staff.passcode')}
          id="passcode"
          type="passcode"
          invalidPattern={/[#']/g}
          objectId={objectId}
          formName={STAFF_CACHE_KEY}
          name="passcode"
          error={errors?.passcode}
          clearError={clearError}
        />

        <SideFormActions cancelAction={cancelAction} isSubmitting={isSubmitting} />
      </Form>
    </FormikProvider>
  );
};
export default StaffForm;
